import { isSameDate, isStringDateBefore } from '@epicuro-next/utilities';
import {
  BasketItem,
  BasketUpdateItem,
  OrderType,
} from 'graphql-api/baskets-api-interfaces';

import { getDeliveryShopKey } from '../../shared/shared';

export const getPastBasketItems = (
  deliveryShop: string,
  basketItemsToMutate: BasketUpdateItem[],
  existingBasketItems: BasketItem[],
  nowStamp: string,
  backOrderEnabled: boolean,
): BasketItem[] => {
  const productIdsToUpdateNow = basketItemsToMutate
    .filter((item) => item.orderType === OrderType.Now)
    .map((item) => item.productId);
  return existingBasketItems.filter((basketItem) => {
    return (
      // shop should match
      getDeliveryShopKey({
        accountId: basketItem.accountId,
        // tslint:disable-next-line:no-non-null-assertion
        addressId: basketItem.addressId!,
      }) === deliveryShop &&
      // we have this product id in NOW basket items and basket items that CS produced
      productIdsToUpdateNow.includes(basketItem.productId) &&
      basketItem.orderType === OrderType.Now &&
      // the requested delivery date of found basket item is earlier than today
      (backOrderEnabled
        ? isStringDateBefore(basketItem.requestedDeliveryDate, nowStamp)
        : !isSameDate(basketItem.requestedDeliveryDate, nowStamp))
    );
  });
};
